import type React from 'react';

import { ImageCarousel } from '@/components/ui/image-carousel';
import useClickOutside from '@/hooks/use-click-outside';
import type { useModal } from '@/components/modals/new/use-modal';
import { Modal } from '@/components/modals/new/modal';

type ViewMediaImage = {
  creatorId?: string | null;
  deletedAt?: string | null;
  estateId?: string | null;
  fileName: string | null;
  name: string | null;
  id: string;
  createdAt?: string | null;
  mediaId: string | null;
  updatedAt?: string | null;
  fileType?: string | null;
  isUsedByFlatfinder?: boolean;
};

export interface ViewMediaModalProps {
  images: ViewMediaImage[];
  preselectedCurrentIndex: number;
  showFileName?: boolean;
  imageBeautificationButtons?: boolean;
  getImageSrc?: (image: ViewMediaImage) => string;
  estateId?: string;
  projectId?: string;
  modal: ReturnType<typeof useModal>;
}

export const ViewMediaModal: React.FC<ViewMediaModalProps> = (props) => {
  const modalContainerRef = useClickOutside<HTMLDivElement>(props.modal.dismiss, true);

  return (
    <Modal
      ref={modalContainerRef}
      className="flex max-h-full w-[90vw] max-w-[1200px] flex-col overflow-hidden !p-4"
      {...props.modal}
      title=""
    >
      <Modal.Body>
        <div className="flex h-full items-center justify-center overflow-hidden">
          <ImageCarousel
            key={`${props.images?.[props.preselectedCurrentIndex]?.mediaId ?? 'no-media'}-${props.preselectedCurrentIndex}`}
            {...props}
            estateId={props.estateId}
            projectId={props.projectId}
            onCloseModal={props.modal.dismiss}
            imageBeautificationButtons={props.imageBeautificationButtons ?? true}
            getImageSrc={props.getImageSrc}
          />
        </div>
      </Modal.Body>
    </Modal>
  );
};
